import { Box } from "@procore/core-react";

import { DetailsToolbar } from "components/toolbars";
import { useNonMarkerUIIsHidden } from "features/markers/markerCreationUtils";

import { useDetailsToolbarRegistration } from "./useDetailsToolbarRegistration";

export function DetailsMenu() {
    const shouldHideUI = useNonMarkerUIIsHidden();

    useDetailsToolbarRegistration();

    return (
        <Box
            style={{
                position: "absolute",
                top: 8,
                left: 8,
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "flex-start",
                gap: 8,
            }}
        >
            <Box
                style={{
                    visibility: shouldHideUI ? "hidden" : undefined,
                    pointerEvents: shouldHideUI ? "none" : undefined,
                }}
            >
                <DetailsToolbar />
            </Box>
        </Box>
    );
}
